export default "__VITE_ASSET__4f621806__"